export default "__VITE_ASSET__BasaKTMA__"